import React, { Component } from "react";
import { FlatButton, Dialog, IconButton } from "material-ui";

import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import closeIcon from "../../images/close_icon.png";
import searchIcon from "../../images/search.png";
import deleteDefaultIcon from "../../images/delete_default.png";
import editDefaultIcon from "../../images/edit_default.png";
import ReactTooltip from "react-tooltip";

export default class ShowGroupList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      groupList: this.props.groupList,
      toastOpen: false,
      responseMsg: "",
      address: "",
      searchTextValue: "",
      openDeleteConfirmPopup: false,
    };
    this.buttonFormatter = this.buttonFormatter.bind(this);
  }

  buttonFormatter(cell, row) {
    return (
      <div>
        <IconButton
          onClick={() => {
            this.deleteMailingTypeListUser(row);
          }}
          style={{ width: "25px", height: "25px", paddingLeft: "20px" }}
        >
          <p data-tip="Delete" data-for="deleteGroup">
            <img src={deleteDefaultIcon} />
          </p>
          <ReactTooltip id="deleteGroup" />
        </IconButton>
      </div>
    );
  }

  componentWillReceiveProps(props) {
    this.showOpenPopup(props.open, props.groupList);
  }

  showOpenPopup = (open, groupList) => {
    this.setState({ open: open, groupList: groupList });
  };

  notifyFormError(data, msg) {
    console.error("Form error:", data);
    alert(msg);
  }

  closeGroupModal = () => {
    this.setState({ open: false, groupList: {} });
    this.props.closeShowPopup();
  };

  // This method is used for searching
  submitSearchForm(searchText) {
    var me = this;
    if (searchText != "" && searchText != null) {
      me.setState({ isLoading: false, searchTextValue: searchText });
    } else {
      me.setState({ searchTextValue: "" });
    }
  }

  clearSearchText = () => {
    this.setState({ searchTextValue: "", open: false });
    this.getAllCompanies();
  };

  deleteMailingTypeListUser = (row) => {
    let { groupList } = this.state;
    if (groupList && groupList.includes(row.id)) {
      if (groupList.length > 0) {
        const index = groupList.indexOf(id);
        if (index > -1) {
          groupList.splice(index, 1);
        }
      }
    } else {
      if (id) {
        groupList.push(id);
      }
    }
    this.setState({ groupList: groupList });
  };

  render() {
    let { groupList, open, searchTextValue, openDeleteConfirmPopup } =
      this.state;
    return (
      <div>
        <Dialog open={open}>
          <div>
            <div style={{ display: "inline-block", fontWeight: "600" }}>
              Groups
            </div>
            <div
              className="searchTextCls"
              style={{ display: "inline-block", marginLeft: "1em" }}
            >
              <input
                type="text"
                value={searchTextValue}
                className="searchInputCls"
                placeholder="Search Group Name"
                onChange={(e) => this.submitSearchForm(e.target.value)}
              />
              <span
                className="searchImgCls"
                onClick={() => {
                  this.clearSearchText();
                }}
              >
                <img src={searchIcon} style={{ width: "16px" }} />
              </span>
            </div>
            <div style={{ display: "inline-block", float: "right" }}>
              <IconButton
                onClick={this.closeGroupModal}
                style={{ width: "25px", height: "25px" }}
              >
                <img src={closeIcon} />
              </IconButton>
            </div>
          </div>
          <hr />
          <BootstrapTable data={groupList} bordered={false} pagination>
            <TableHeaderColumn
              isKey={true}
              dataField="_id"
              width="120"
              hidden={true}
            >
              Id
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="name"
              width="120"
              tdStyle={{ background: "#fff" }}
            >
              Group Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="button"
              dataFormat={this.buttonFormatter}
              width="20"
              tdStyle={{ background: "#fff" }}
            >
              Action
            </TableHeaderColumn>
          </BootstrapTable>
        </Dialog>
        <Dialog
          title="Delete User"
          open={openDeleteConfirmPopup}
          onRequestClose={this.closeDeleteConfirmPopup}
          style={{ width: "50%", textAlign: "center" }}
        >
          Are you sure you want to delete this user?
          <br />
          <br />
          <FlatButton
            type="button"
            className="flatButtonCls"
            onTouchTap={this.deleteConfirmPopupClick}
          >
            Yes
          </FlatButton>
          <FlatButton
            type="button"
            style={{ marginLeft: "2rem" }}
            className="flatButtonCls"
            onTouchTap={this.closeDeleteConfirmPopup}
          >
            No
          </FlatButton>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/documentUploader/ShowGroupList.js